import { parseISO } from "date-fns"

export default function () {
  document.querySelectorAll("[data-unformatted-date]").forEach((el) => {
    const parsedTime = parseISO(el.dataset.unformattedDate)
    const localizedTime = parsedTime.toLocaleString()
    el.innerText = localizedTime
  })
}
